import {useCallback, useContext} from "react";

import ScrollContext from "../../utils/scrolling/ScrollContext";

const elementMarkerClass = "scrolled-element";

function useKeepContentScrollPosition(): [
	keep: (delay: number) => ReturnType<typeof setTimeout>,
	markerClass: string
] {
	const {scrollToTop, withForcedScroll} = useContext(ScrollContext);

	const keep = useCallback(
		(delay: number) =>
			withForcedScroll(() => keepContentScrollPosition(scrollToTop, delay)),
		[withForcedScroll, scrollToTop]
	);

	return [keep, elementMarkerClass];
}

function keepContentScrollPosition(
	scrollToTop: (pos: number) => void,
	delay: number
) {
	const {exerciseElem, top: prevTop} = selectFirstVisibleElement();

	return setTimeout(() => {
		if (exerciseElem) {
			const scrollAdjustment =
				exerciseElem.getBoundingClientRect().top - prevTop;

			scrollToTop(document.documentElement.scrollTop + scrollAdjustment);
		}
	}, delay);
}

function selectFirstVisibleElement() {
	let exerciseElem: Element | null = null;
	let exPrevTop = 0;

	const exercises = Array.from(
		document.querySelectorAll(`.${elementMarkerClass}`)
	);

	for (const e of exercises) {
		const {top} = e.getBoundingClientRect();
		if (top >= 0) {
			exerciseElem = e;
			exPrevTop = top;
			break;
		}
	}

	return {exerciseElem: exerciseElem, top: exPrevTop};
}

export default useKeepContentScrollPosition;
